import { __module as o } from "./index.es80.js";
import { __require as h } from "./index.es81.js";
import { __require as M } from "./index.es82.js";
import q from "./index.es83.js";
var c;
function C() {
  if (c) return o.exports;
  c = 1;
  var a = h(), f = M(), u = q;
  u.elementNames.__proto__ = null, u.attributeNames.__proto__ = null;
  var m = {
    __proto__: null,
    style: !0,
    script: !0,
    xmp: !0,
    iframe: !0,
    noembed: !0,
    noframes: !0,
    plaintext: !0,
    noscript: !0
  };
  function s(r, t) {
    if (r) {
      var e = "", i;
      for (var n in r)
        i = r[n], e && (e += " "), t.xmlMode === "foreign" && (n = u.attributeNames[n] || n), e += n, (i !== null && i !== "" || t.xmlMode) && (e += '="' + (t.decodeEntities ? f.encodeXML(i) : i.replace(/\"/g, "&quot;")) + '"');
      return e;
    }
  }
  var l = {
    __proto__: null,
    area: !0,
    base: !0,
    basefont: !0,
    br: !0,
    col: !0,
    command: !0,
    embed: !0,
    frame: !0,
    hr: !0,
    img: !0,
    input: !0,
    isindex: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
  }, d = o.exports = function(r, t) {
    !Array.isArray(r) && !r.cheerio && (r = [r]), t = t || {};
    for (var e = "", i = 0; i < r.length; i++) {
      var n = r[i];
      n.type === "root" ? e += d(n.children, t) : a.isTag(n) ? e += v(n, t) : n.type === a.Directive ? e += g(n) : n.type === a.Comment ? e += b(n) : n.type === a.CDATA ? e += p(n) : e += x(n, t);
    }
    return e;
  }, _ = [
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
  ];
  function v(r, t) {
    t.xmlMode === "foreign" && (r.name = u.elementNames[r.name] || r.name, r.parent && _.indexOf(r.parent.name) >= 0 && (t = Object.assign({}, t, { xmlMode: !1 }))), !t.xmlMode && ["svg", "math"].indexOf(r.name) >= 0 && (t = Object.assign({}, t, { xmlMode: "foreign" }));
    var e = "<" + r.name, i = s(r.attribs, t);
    return i && (e += " " + i), t.xmlMode && (!r.children || r.children.length === 0) ? e += "/>" : (e += ">", r.children && (e += d(r.children, t)), (!l[r.name] || t.xmlMode) && (e += "</" + r.name + ">")), e;
  }
  function g(r) {
    return "<" + r.data + ">";
  }
  function x(r, t) {
    var e = r.data || "";
    return t.decodeEntities && !(r.parent && r.parent.name in m) && (e = f.encodeXML(e)), e;
  }
  function p(r) {
    return "<![CDATA[" + r.children[0].data + "]]>";
  }
  function b(r) {
    return "<!--" + r.data + "-->";
  }
  return o.exports;
}
export {
  C as __require
};
//# sourceMappingURL=index.es70.js.map
